import { getRequest, putRequest } from "../api";

const path = "admin/ext-billing/invoice/redeem";

export const getAllRedeem = async (page, search, start, end, sortBy, order) => {
  if (isNaN(page)) {
    page = 0;
  }

  page = isNaN(page) ? 0 : page - 1;
  if (page < 0) page = 0;

  let endpoint = `${path}?page=${page}&pageSize=25`;
  if (search != null && search.trim() !== "") {
    endpoint = `${endpoint}&search=${search}`;
  }
  if (start != null && start.trim() !== "") {
    endpoint = `${endpoint}&start=${start}`;
  }
  if (end != null && end.trim() !== "") {
    endpoint = `${endpoint}&end=${end}`;
  }

  if (sortBy != null && sortBy.trim() !== "") {
    endpoint = `${endpoint}&sortBy=${sortBy}`;

    if (order != null && order.trim() !== "") {
      endpoint = `${endpoint}&order=${order}`;
    }
  }

  try {
    const response = await getRequest(endpoint, true);
    return response;
  } catch (err) {
    throw err;
  }
};

export const approveRedeem = async (id) => {
  try {
    const response = await putRequest(`${path}/${id}/approve`, {}, true);
    return response;
  } catch (err) {
    throw err;
  }
};
